import { useState, useCallback } from "react";
import qs from "qs";
import {
  VIRTUAL_BORE_EVENTS,
  VB_URL_PARAMS,
} from "../../components/VirtualBore/constants";

/**
 * Hook for managing virtual bore tool state and URL interactions
 * Provides crosshair cursor, URL parameter management, and tool state
 */
const useVirtualBoreTool = () => {
  const [isToolEnabled, setIsToolEnabled] = useState(false);

  const toggleTool = useCallback(() => {
    setIsToolEnabled((prev) => !prev);
  }, []);

  const disableTool = useCallback(() => {
    setIsToolEnabled(false);
  }, []);

  const clearVirtualBoreParams = useCallback(() => {
    const currentParams = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });

    // Remove all virtual bore parameters
    Object.values(VB_URL_PARAMS).forEach((param) => {
      delete currentParams[param];
    });

    const newSearch = qs.stringify(currentParams, { addQueryPrefix: true });
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}${newSearch}`
    );

    // Notify listeners
    window.dispatchEvent(
      new CustomEvent(VIRTUAL_BORE_EVENTS.URL_PARAMS_CHANGED)
    );
  }, []);

  const setCoordinatesInUrl = useCallback(
    (coordinates) => {
      if (!isToolEnabled || !coordinates?.lat || !coordinates?.lon) return;

      const currentParams = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
      });

      // Clear existing virtual bore params
      delete currentParams[VB_URL_PARAMS.LAT];
      delete currentParams[VB_URL_PARAMS.LON];

      // Add new coordinates
      currentParams[VB_URL_PARAMS.LAT] = coordinates.lat.toString();
      currentParams[VB_URL_PARAMS.LON] = coordinates.lon.toString();

      const newSearch = qs.stringify(currentParams, { addQueryPrefix: true });
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}${newSearch}`
      );

      // Notify listeners
      window.dispatchEvent(
        new CustomEvent(VIRTUAL_BORE_EVENTS.URL_PARAMS_CHANGED)
      );

      // Auto-disable tool after use
      setIsToolEnabled(false);
    },
    [isToolEnabled]
  );

  return {
    isToolEnabled,
    toggleTool,
    disableTool,
    setCoordinatesInUrl,
    clearVirtualBoreParams,
  };
};

export default useVirtualBoreTool;
